export { SticksProductDetailsPage } from "./SticksProductDetailsPage";
